import React from "react";
import {Modal, ScrollView, View} from "react-native";
import MainStyle from "../../MainStyle";
import Div from "../lib/Div";
import P from "../lib/P";
import FontAwesome5 from "@expo/vector-icons/FontAwesome5";
import Btn from "../components/Btn";

type Props = {visible: boolean, onClose: () => void};

const CompleteKYC = (props: Props) => {
  const {visible} = props;

  return (
    <Modal animationType="fade" transparent visible={visible} statusBarTranslucent={false}
           hardwareAccelerated={false} onRequestClose={props.onClose}>
      <View style={[MainStyle.fix_gradient_and_modal_error_in_landscape, MainStyle.flex1, MainStyle.bg_filter_modal]}>
        <ScrollView contentContainerStyle={MainStyle.flex1}>
          <Div minH="100%" alignItems="center" justifyContent="center">
            <Div bg="#131314" w={343} rounded={16} overflow="hidden">
              <Div position="relative" bg="#252526" justifyContent="center">
                <P fontFamily="DavisSans-Medium" ta="center" lh={48}>Complete KYC</P>
                <FontAwesome5
                  name="times" size={28} color="white" style={[MainStyle.absolute, MainStyle.r_10]}
                  onPress={props.onClose}
                />
              </Div>

              <P fontFamily="DavisSans-Regular" mx={16} ta="center" mt={24} mb={30}>
                We will need to verify your identity to withdraw or deposit.
              </P>

              <Btn mb={30} bg="#3369FF" rounded={4} mx={16} onPress={props.onClose}>
                <P lh={56} ta="center" fontFamily="DavisSans-Medium" color="white">Complete KYC</P>
              </Btn>

              <Btn mb={90} bg="#C73232" rounded={4} mx={16} onPress={props.onClose}>
                <P lh={56} ta="center" fontFamily="DavisSans-Medium" color="white">Cancel</P>
              </Btn>
            </Div>
          </Div>
        </ScrollView>
      </View>
    </Modal>
  );
};

export default CompleteKYC;
